import { useSelector } from 'react-redux';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { TableSortLabel } from '@/shared/components/MaterialTableElements';
import { RootState } from '@/stores';

const rows = [
    { id: 'id', disablePadding: true, label: 'id' },
    { id: 'email', disablePadding: false, label: 'Email' },
    // Spec v2 §03: the table showed neither name nor type. Both already exist
    // (or now do) on the user document — this is surfacing, not new data.
    { id: 'name', disablePadding: false, label: 'Name' },
    { id: 'crmType', disablePadding: false, label: 'Type' },
    { id: 'cohort', disablePadding: false, label: 'Cohort' },
    { id: 'latestOrderStatus', disablePadding: false, label: 'Shipment' },
    { id: 'telegramGroupJoined', disablePadding: false, label: 'TG joined' },
    { id: 'role', disablePadding: false, label: 'Role' },
    { id: 'subscriptionPlan', disablePadding: false, label: 'Subscription' },
    { id: 'onBoarded', disablePadding: false, label: 'OnBoarded' },
    { id: 'active', disablePadding: false, label: 'Active' },
    { id: 'personaOnboarded', disablePadding: false, label: 'Persona Onboarded' },
    { id: 'signupSource', disablePadding: false, label: 'Source' },
    { id: 'referredByCode', disablePadding: false, label: 'Referred by' },
    { id: 'created_at', disablePadding: false, label: 'Created At' },
    { id: 'updated_at', disablePadding: false, label: 'Updated At' },
];

interface MatTableHeadProps {
    onRequestSort: (event: React.MouseEvent<unknown>, property: string) => void;
    order: 'asc' | 'desc';
    orderBy: string;
}

const MatTableHead = ({ order, orderBy, onRequestSort }: MatTableHeadProps) => {
    const rtl = useSelector((state: RootState) => state.rtl);

    return (
        <TableHead>
            <TableRow>
                {rows.map((row) => (
                    <TableCell
                        key={row.id}
                        align={rtl.direction === 'rtl' ? 'right' : 'left'}
                        padding={row.disablePadding ? 'none' : 'normal'}
                        sortDirection={orderBy === row.id ? order : false}
                    >
                        <TableSortLabel
                            active={orderBy === row.id}
                            direction={order}
                            onClick={(event) => onRequestSort(event, row.id)}
                            className="material-table__sort-label"
                            dir="ltr"
                        >
                            {row.label}
                        </TableSortLabel>
                    </TableCell>
                ))}
            </TableRow>
        </TableHead>
    );
};

export default MatTableHead;
